import {Context} from "../../../index";
import {useContext} from "react";

export const useTriggerTypes = () => {
    const {features} = useContext(Context);

    const triggerTypes = {
        'REGULAR_PATIENT': 'Постоянное посещение приемов',
        'FIRST_APPOINTMENT': 'После первого приема',
        'DATE': 'Конкретная дата',
        'INACTIVE_PATIENT': 'Отсутствие приемов',
        'REMIND_APPOINTMENT': 'Напоминание о приеме (дни)',
        'REPEAT_APPOINTMENT': 'Напоминание на повторный прием',
        'DRINKS_BEFORE_APPOINTMENT': 'Предложение напитков перед приемом',
        'PROMO_END': 'Напоминание об окончании акции',
        'REMIND_BONUS_BURN': 'Напоминание о сгорании бонусов',
        'REMIND_BONUS_COUNT': 'Напоминание о бонусах',
        'BIRTHDAY': 'День рождения',
        'SURVEY_AFTER_APPOINTMENT': 'Опрос после приема',
        'REMIND_APPOINTMENT_SAME_DAY': 'Напоминание о приеме (часы)',
    };

    if(features.features.pets) {
        triggerTypes['PETS_BIRTHDAY'] = 'День рождения питомца';
    }

    return triggerTypes;
}